export const OPT_IN = "OptIn";
export const VERIFICATION_SETTINGS = "VerificationSettings";
export const PSA_CONTACT_VALIDATION = "PsaContactValidation";
export const SECURE_DATA = "SecureData";
export const SECURE_DATA_REQUEST = "SecureDataRequest";
